import { render, staticRenderFns } from "./FeatureFeedbacks.vue?vue&type=template&id=d8bedee2&scoped=true&"
import script from "./FeatureFeedbacks.vue?vue&type=script&lang=js&"
export * from "./FeatureFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./FeatureFeedbacks.vue?vue&type=style&index=0&id=d8bedee2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8bedee2",
  null
  
)

export default component.exports